export default function capitalize(str) {
    const string = String(str);
    return string ? `${string.charAt(0).toUpperCase()}${string.slice(1)}` : null;
}
